module.exports = "<div id=\"persons-onboard-graph\" class=\"graph\"></div>"


//////////////////
// WEBPACK FOOTER
// ./client/app/dashboard/person-onboard-graph.component.html
// module id = 1416
// module chunks = 1